import { ApMenu, colors } from '@alixpartners/ui-components';
import styled, { css } from 'styled-components';

export const StyledMenu = styled(ApMenu)`
	padding-bottom: 0 !important;
	overflow: hidden !important;
	display: flex;
	flex-direction: column;
	max-width: 300px !important;
	width: 300px !important;
	max-height: calc(100% - 102px) !important;

	${({ isFullHeight }) =>
		isFullHeight &&
		css`
			height: 100%;
		`};
`;

export const CounterWrapper = styled.div`
	position: absolute;
	right: 8px;
	top: -8px;
	border-radius: 16px;
	background-color: ${colors.green2};
	height: 16px;
	min-width: 16px;
	color: white;
	font-size: 11px;
	font-weight: 500;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 4px;
	z-index: 2;
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	max-height: 100%;
	height: 100%;
	overflow: hidden;
`;

export const NoData = styled.div`
	display: flex;
	height: 100%;
	width: 100%;
	font-size: 16px;
	line-height: 20px;
	color: ${colors.grey6};
	padding: 8px 9px;
`;

export const ListWrapper = styled.div`
	overflow: auto;
`;

export const Footer = styled.div`
	padding: 8px 16px;
	border-top: 1px solid ${colors.grey2};
`;

export const TitleWraper = styled.div`
	padding: 8px 10px;
	display: flex;
	align-items: center;
	cursor: pointer;
`;

export const Label = styled.div`
	font-size: 16px;
	line-height: 20px;
	color: ${colors.grey7};
	padding-left: 6px;
	cursor: default;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;

	span {
		font-weight: 500;
	}
`;
